/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 17:30:18
 * @LastEditTime: 2021-11-26 14:27:13
 * @LastEditors: wangshengqiang
 * @Description: 计划
 */
import React from 'react';
import classnames from 'classnames';
import { Tabs } from 'zarm';
import Render from '@/components/Render';
import { useStore } from '@/store'; // const { Panel } = Tabs;

const PlanTabs = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    children
  } = props;

  const _children = children || [];

  const planId = useStore('PLAN_ID');
  const cls = classnames({
    'components-plan-tabs-render': true
  }); // const ComponentClass = _children.length > 1 ? Tabs : 'div';

  const ComponentClass = 'div'; // const renderChildren = () => {
  //   if (_children.length <= 1) {
  //     return (
  //       <Render components={_children} />
  //     );
  //   }
  //   return _children.map((child, index) => {
  //     const components = [child];
  //     return (
  //       <>
  //         <Render components={components} />
  //       </>
  //     );
  //   });
  // };

  const renderChildren = () => {
    let child = _children;

    if (_children.length > 1) {
      if (!planId) {
        child = [_children[0]];
      } else {
        child = _children.find(item => {
          return item.attrs.planId === planId;
        });
        child = [child];
      }
    }

    return /*#__PURE__*/React.createElement(Render, {
      components: child
    });
  };

  return /*#__PURE__*/React.createElement(ComponentClass, {
    className: cls,
    ref: ref
  }, renderChildren());
});
export default PlanTabs;